//#region src/integrations/huggingface/huggingfaceTypes.ts
const HUGGINGFACE_INTEGRATION_ID = "huggingface";
const HUGGINGFACE_DEFAULT_BASE_URL = "https://router.huggingface.co/v1";
const HUGGINGFACE_LOGO_URL = "/logos/huggingface/logo.svg";

//#endregion
export { HUGGINGFACE_DEFAULT_BASE_URL, HUGGINGFACE_INTEGRATION_ID, HUGGINGFACE_LOGO_URL };
//# sourceMappingURL=huggingfaceTypes.js.map